import { BaseService } from "./BaseService";
import { FunctionGroup, MeasuresType } from "../types/app.enums";
import { Measures } from "../types/app.interfaces";

export class TargetSizeService extends BaseService {
  burgissCalcTargetSize(
    portfolioId: any[][],
    endDate?: any,
    currency?: any,
    alternateBaseCurrency?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      portfolioId,
      endDate,
      currency,
      MeasuresType.TargetSize,
      alternateBaseCurrency,
      uniqueCellId
    );
    return super._pushOperation(
      "burgissCalcTargetSize",
      objRequest,
      this.APICONFIG.GETPORTFOLIOANALYSIS,
      FunctionGroup.TargetSize
    );
  }
  createPayload(
    portfolioId: any[][] = null,
    endDate: any = null,
    currency: string = null,
    measure: string = null,
    alternateBaseCurrency: any = null,
    alias: string = null
  ) {
    const targetSizeObject: Measures = {
      excludeBalanceSheetItems: false,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: null,
      percentile: null,
      currency: null,
      returnConstituentCount: false,
      investmentID: null,
      portfolioID: String(portfolioId).toUpperCase() == "ALL" ? "-1" : String(portfolioId),
      isHoldingCalc: false,
      returnPooledResult: true,
      baseCurrency: String(currency).toLowerCase() === "true",
      alternateBaseCurrency: alternateBaseCurrency,
      adjustToMostRecent: false,
      measure: measure,
      beginDate: null,
      endDate: endDate,
      year: null,
      indexID: null,
      premium: null,
      idType: "p",
      selectionsetID: null,
      assetID: null,
      weightingMethod: null,
      value: null,
      filter: null,
      attributeName: null,
      rankValue: null,
      bMUHistoricalWindowLengthQtrs: 0,
      maxAgeDiffYears: null,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      numSimulations: null,
      desiredSampleSize: null,
      minSampleSize: null,
      sampleStatistic: null,
      stopOn: null,
      requireReportedValuation: 0,
      alias: alias,
      currencyHedgesetId: "",
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: false,
      dynamicParameter: "",
      universe: null,
      weight: null,
      commitment: null,
    };
    return targetSizeObject;
  }
}
